import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  public lstErros: any;

  constructor(
    public alertCtrl: AlertController,
  ) {
    this.lstErros = {
      0: `<b>SEM CONEXÃO</b><br/> Por favor, conecte-se a internet`,
      24: 'outro erro',
      200: 'Parametros inválidos enviado ao sevidor',
      404: `Erro de comunicação com o servidor<br/><h4>Entre em contato com o suporte imediatamente</h4>`,
      500: `Erro no servidor`,
      50000: `NOME INVÁLIDO<br/> Insira seu nome completo`,
      50001: `TELEFONE INVALIDO`,
      50002: `<b>EMAIL INVÁLIDO</b><br/>`,
      50003: `<b>SENHA INVÁLIDA</b><br/>Por favor, insira uma senha com no minimo 6 caracteres`,
      50004: `<b>CPF INVÁLIDO</b>`,
      50005: `<b>RG INVÁLIDO</b>`,
      50006: `<b>CNH INVÁLIDO</b>`,
      50007: `<b>PLACA DO VEÍCULO INVALIDA</b><br/><p>Insira uma placa válida</p>`,
      50010: `<b>LOGIN OU SENHA INVÁLIDOS</b><br/><p>Verifique se seu email ou senha foram escritos corretamente ou clique em 'Esqueci minha senha'.</p>`
    };
  }

  async erros(erro: number) {
    console.log(erro, this.lstErros[erro]);

    let mensagem: string;

    mensagem = this.lstErros[erro];

    const alert = await this.alertCtrl.create({
      message: mensagem,
    });

    await alert.present();
  }
}
